import React, {Component} from "react";
import {closeAlert} from "../../../actions/commonsActions";
import {goBack, push} from "connected-react-router";
import {SUPER_ADMIN, USER_ROLES} from "../../../helpers/constants";
import {connect} from "react-redux";
import {
    fetchPlayerActiveSalesPoints,
    fetchPlayerActiveSalesPointsCsv
} from "../../../actions/player/playerActiveSalesPointsActions";
import {Alert, Card, CardBody, CardTitle} from "reactstrap";
import {I18n} from "../../../I18n/components/player";
import PlayerActiveSalesPointsControls from "./PlayerActiveSalesPointsControls";
import {fetchOperatorTinyCompanies, fetchTinyCompaniesWithOperator} from "../../../actions/companyActions";
import {fetchTinyStores, fetchTinyStoresWithOperator} from "../../../actions/storesActions";
import PlayerActiveSalesPointsList from "./PlayerActiveSalesPointsList";
import {createCsv} from "../../../helpers/createCsv";
import {isPlayerPermission} from "../../../helpers/companyService";
import swal from "sweetalert";

class PlayerActiveSalesPoints extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mediaOwnerCompanyIdFilter: null,
            contributorCompanyIdFilter: null,
            isCsvLoading: false,
        };
    }

    componentDidMount() {
        (async () => {
            const {lang, company, authority} = this.props;

            if (!isPlayerPermission(company, authority)) {
                await swal(I18n[lang].contactUsToAccessThis, '', 'error')
                    .then(() => this.props.goBack())
                return;
            }

            await Promise.all(this.getAdditionalDataFetches());
            await this.fetchPaginatedData(0);
        })();
    }

    getAdditionalDataFetches = () => {
        const {authority, company} = this.props;
        if (authority === SUPER_ADMIN) {
            return [
                this.props.fetchOperatorTinyCompanies(),
                this.props.fetchTinyStores()
            ];
        } else if (company.types.includes('RETAIL')) {
            return [
                this.props.fetchTinyStores({companyIds: [company.id]})
            ];
        } else if (company.types.includes('OPERATOR')) {
            return [
                this.props.fetchTinyCompaniesWithOperator(company.id),
                this.props.fetchTinyStoresWithOperator(company.id)
            ];
        }
    }

    fetchPaginatedData = async currentPage => {
        const {authority, company} = this.props;
        const {mediaOwnerCompanyIdFilter, contributorCompanyIdFilter} = this.state;
        const isSuperAdmin = authority === SUPER_ADMIN;
        await this.props.fetchPlayerActiveSalesPoints({
            mediaOwnerCompanyId: isSuperAdmin ? mediaOwnerCompanyIdFilter : company.id,
            contributorCompanyId: isSuperAdmin || company.types.includes('OPERATOR') ? contributorCompanyIdFilter : company.id,
            page: currentPage
        });
        await this.setState({
            currentPage
        });
    };

    setCurrentPage = async currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage)
        });
    };

    onFilterClick = name => {
        return event => {
            const value = event.target.value;
            this.setState(() => {
                return {
                    [`${name}`]: value
                }
            });
        }
    };

    getFiltered = async () => {
        await this.fetchPaginatedData(0);
    };

    clearFilters = () => {
        this.setState({
            mediaOwnerCompanyIdFilter: '',
            contributorCompanyIdFilter: '',
        }, async () => {
            await this.fetchPaginatedData(0);
        })
    };

    downloadCsv = () => {
        const {authority, company} = this.props;
        const {mediaOwnerCompanyIdFilter, contributorCompanyIdFilter} = this.state;
        this.setState({
            isCsvLoading: true
        }, async () => {
            const isSuperAdmin = authority === SUPER_ADMIN;
            const response = await this.props.fetchPlayerActiveSalesPointsCsv({
                mediaOwnerCompanyId: isSuperAdmin ? mediaOwnerCompanyIdFilter : company.id,
                contributorCompanyId: isSuperAdmin || company.types.includes('OPERATOR')
                    ? contributorCompanyIdFilter
                    : company.id,
            });
            if (response) {
                createCsv(response);
            }
            this.setState({
                isCsvLoading: false
            })
        })
    };

    getAccessibleCompanies = () => {
        const {authority, company, companies, tinyCompaniesWithOperator} = this.props;
        if (authority === SUPER_ADMIN) return companies;
        else if (company.types.includes('OPERATOR')) return tinyCompaniesWithOperator;
        else return null;
    }

    render() {
        const {
            lang,
            authority,
            loading,
            company,
            operatorTinyCompanies,
            tinyStores,
            tinyStoresWithOperator,
            playerActiveSalesPoints,
            pagination
        } = this.props;
        const {
            currentPage,
            mediaOwnerCompanyIdFilter,
            contributorCompanyIdFilter,
            isCsvLoading
        } = this.state;

        const companiesList = this.getAccessibleCompanies();

        const storesList = authority === SUPER_ADMIN || company.types.includes('RETAIL')
            ? tinyStores
            : tinyStoresWithOperator;

        const playerActiveSalesPointsList = loading
            ? <div className="loading">Loading...</div>
            : <PlayerActiveSalesPointsList
                authority={authority}
                lang={lang}
                company={company}
                companies={companiesList}
                stores={storesList}
                activeSalesPoints={playerActiveSalesPoints}
                currentPage={currentPage}
                setCurrentPage={this.setCurrentPage}
                totalPages={pagination.totalPages}
            />

        const controls = authority === SUPER_ADMIN || company.types.includes('OPERATOR')
            ? <PlayerActiveSalesPointsControls
                lang={lang}
                authority={authority}
                company={company}
                companies={companiesList}
                operatorTinyCompanies={operatorTinyCompanies}
                mediaOwnerCompanyIdFilter={mediaOwnerCompanyIdFilter}
                contributorCompanyIdFilter={contributorCompanyIdFilter}
                onFilterClick={this.onFilterClick}
                getFiltered={this.getFiltered}
                clearFilters={this.clearFilters}
                downloadCsv={this.downloadCsv}
                isCsvLoading={isCsvLoading}
            /> : null

        return (
            <div>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-play-circle-outline mr-2"/>
                            {I18n[lang].player + ' / ' + I18n[lang].activeSalesPoints}
                        </div>
                    </CardTitle>

                    <CardBody>
                        {controls}
                        {playerActiveSalesPointsList}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchPlayerActiveSalesPoints: query => dispatch(fetchPlayerActiveSalesPoints(query)),
        fetchPlayerActiveSalesPointsCsv: query => dispatch(fetchPlayerActiveSalesPointsCsv(query)),
        fetchOperatorTinyCompanies: () => dispatch(fetchOperatorTinyCompanies()),
        fetchTinyCompaniesWithOperator: query => dispatch(fetchTinyCompaniesWithOperator(query)),
        fetchTinyStores: query => dispatch(fetchTinyStores(query)),
        fetchTinyStoresWithOperator: (operatorCompanyId) => dispatch(fetchTinyStoresWithOperator(operatorCompanyId)),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        goBack: () => dispatch(goBack()),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    playerActiveSalesPoints: state.playerActiveSalesPoints.playerActiveSalesPoints,
    pagination: state.playerActiveSalesPoints.pagination,
    loading: state.playerActiveSalesPoints.loading,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    companies: state.companiesReducer.companies,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    operatorTinyCompanies: state.operatorTinyCompaniesReducer.operatorTinyCompanies,
    tinyCompaniesWithOperator: state.tinyCompaniesWithOperatorReducer.tinyCompanies,
    tinyStores: state.tinyStoresReducer.tinyStores,
    tinyStoresWithOperator: state.tinyStoresWithOperatorReducer.tinyStoresWithOperator,
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(PlayerActiveSalesPoints)


// WEBPACK FOOTER //
// ./src/components/Player/PlayerActiveSalesPoints/PlayerActiveSalesPoints.js